import type { CreditNote } from '~/api/creditNotes/types';

import { Separator } from '~/components';

import { mobileActionsStyle, mobileCellStyle, mobileFooterStyle, mobileHeaderStyle, mobileSeparatorStyle } from './creditNoteCell.css';
import { CreditNoteClientCell } from './CreditNoteClientCell';
import { CreditNoteDocumentDateCell } from './CreditNoteDocumentDateCell';
import { CreditNoteOptionsCell } from './CreditNoteOptionsCell';
import { CreditNoteStatusCell } from './CreditNoteStatusCell';
import { CreditNoteTitleCell } from './CreditNoteTitleCell';
import { CreditNoteTotalCell } from './CreditNoteTotalCell';

type Props = {
  creditNote: CreditNote;
};

export const CreditNoteMobileCell = ({ creditNote }: Props) => {
  return (
    <div className={mobileCellStyle}>
      <div className={mobileHeaderStyle}>
        <div>
          <CreditNoteTitleCell creditNote={creditNote} />

          <CreditNoteClientCell creditNote={creditNote} />
        </div>

        <div className={mobileActionsStyle}>
          <CreditNoteStatusCell creditNote={creditNote} />

          <CreditNoteOptionsCell creditNote={creditNote} />
        </div>
      </div>

      <Separator className={mobileSeparatorStyle} />

      <div className={mobileFooterStyle}>
        <CreditNoteDocumentDateCell creditNote={creditNote} />

        <CreditNoteTotalCell value={-1 * creditNote.calculationData.fcExclVat} />
      </div>
    </div>
  );
};
